import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { yellow } from '@mui/material/colors';
import FeaturedIcon from '@mui/icons-material/Spa';

// appsolut base components
import StyledBox from '../../components/controls/StyledBox';
import StyledTypography from '../../components/controls/StyledTypography';
import StyledHtmlViewer from '../../components/controls/StyledHtmlViewer';

function Content({ header, title, featured, featuredLabel, teaser, body, footer }) {
  return (
    <Grid container>
      {header && (
        <Grid item xs={12}>
          <StyledTypography
            variant="button"
            opacity={0.7}
            textTransform="uppercase"
            fontWeight="bold"
            mb={1}
          >
            {header}
          </StyledTypography>
        </Grid>
      )}
      {title && (
        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="flex-end">
            <StyledTypography variant="h2" mb={3}>
              {title}
            </StyledTypography>
            {featured && (
              <Tooltip title={featuredLabel}>
                <StyledBox pb={2}>
                  <FeaturedIcon fontSize="large" sx={{ color: yellow[500] }} />
                </StyledBox>
              </Tooltip>
            )}
          </Stack>
        </Grid>
      )}
      {teaser && (
        <Grid item xs={12}>
          <StyledTypography variant="subtitle1" mb={3}>
            {teaser}
          </StyledTypography>
        </Grid>
      )}
      {body && (
        <Grid item xs={12}>
          <StyledHtmlViewer>
            <StyledTypography
              component="div"
              variant="body2"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </StyledHtmlViewer>
        </Grid>
      )}
      {footer && (
        <Grid item xs={12}>
          <StyledBox pt={{ xs: 2, md: 3 }}>
            <StyledHtmlViewer>
              <StyledTypography
                component="div"
                variant="body2"
                dangerouslySetInnerHTML={{ __html: footer }}
              />
            </StyledHtmlViewer>
          </StyledBox>
        </Grid>
      )}
    </Grid>
  );
}

Content.defaultProps = {
  featured: false,
  featuredLabel: 'Für Sie ausgewählt',
};

Content.propTypes = {
  header: PropTypes.string,
  title: PropTypes.string,
  featured: PropTypes.bool,
  featuredLabel: PropTypes.string,
  teaser: PropTypes.string,
  body: PropTypes.string,
  footer: PropTypes.string,
};

export default Content;
